import Icon from "@ant-design/icons";
import {Image} from "antd";
import {
    HSCIconImg
} from "../../../../assets";


export const MyIcon = (props) => <Image src={HSCIconImg} preview={false}/>
